module.exports = __webpack_public_path__ + "static/media/jardines05.daa0e965.jpg";